const translations: any = {
  J: 'Jupiter',
  U: 'Uranus',
  N: 'Neptune',
  P: 'Pluto',
  E: 'Earth',
  M: 'Mercury',
  S: 'Saturn',
  R: 'Rift',
  'ξ': 'Epsilon',
  'β': 'Beta',
  'K': 'Kappa',
  'O': 'Omicron',
  'α': 'Alpha',
  'Q': 'Quion',
  'τ': 'Tensilon',
  'Z': 'Zeta',
}

export default function translateOrbitingPlanet(key: string) {
  return translations[key] || key
}
